export type TimingValue = number

export interface TimeStatsCollector {

    collectTiming(context: string, timingName: string, timingValue: TimingValue): Promise<void>;

    collectMeasure(context: string, perf: PerformanceMeasure): Promise<void>;

}


export abstract class TimeStatsCollectorAbstractBase implements TimeStatsCollector {

    abstract collectTiming(context: string, timingName: string, timingValue: TimingValue): Promise<void>;

    collectMeasure(context: string, perf: PerformanceMeasure): Promise<void> {
        return this.collectTiming(context, perf.name, perf.duration);
    }
}

